export default "__VITE_ASSET__Cj_EcGf1__"